import type { ReactNode } from 'react';
import { useCallback } from 'react';

import { useIsUserAuthenticated } from '@/hooks/useIsUserAuthenticated';
import { loginWithRedirect } from '@/utils/auth';

import { AuthStrategyContext } from './AuthStrategyContext';
import type { AuthStrategyContextValue, RedirectStrategy } from './types';

type RedirectStrategyProviderProps = {
  strategy: RedirectStrategy;
  children: ReactNode;
};

// gloss
export const RedirectStrategyProvider = ({ children, strategy }: RedirectStrategyProviderProps) => {
  const isUserAuthenticated = useIsUserAuthenticated();

  const handleAuth = useCallback(() => {
    if (isUserAuthenticated) return Promise.resolve();
    loginWithRedirect();
    return Promise.reject(new Error('Redirecting to login'));
  }, [isUserAuthenticated]);

  const contextValue: AuthStrategyContextValue = { strategy, handleAuth };

  return <AuthStrategyContext.Provider value={contextValue}>{children}</AuthStrategyContext.Provider>;
};
